import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { defaultDataAcessor } from 'src/app/core/helpers/mat-sort-data-accessor';
import { IPeaCriterioQuestionarioModel } from 'src/app/models/pea-criterio-questionario.model';
import { IBaseModel } from 'src/app/models/base.model';
import { IQuestionarioModel } from 'src/app/models/questionario.model';
import { QuestionarioService } from 'src/app/services/questionario.service';
import { BaseListComponent } from 'src/app/shared/components/base-list/base-list.component';
import { IListaQuestionarioRespostaUGModel, IQuestionarioUGModel } from 'src/app/models/questionario-ug.model';
import { EntendendoEntidadeService } from 'src/app/services/entendendo-entidade.service';
import { FiltroQuestionarioUG } from 'src/app/models/filtro-questionario-ug.model';
import { SharedService } from "../../services/shared.service";

const sortingDataAccessor = (item, property) => {

  switch (property) {
    case 'nomefuncionalidade':
      return item.nomefuncionalidade.trim().toLowerCase();;
    case 'ug':
      return item.ugSigla.trim().toLowerCase();;
    case 'responsavel':
      return item.nomeResponsavel.trim().toLowerCase();;
    case 'dataEnvio':
      return item.dataCriacaoFormatada.trim().toLowerCase();;
    case 'dataPrazo':
      return item.dataPrazo.trim().toLowerCase();;
    default:
      return item[property];
  }
}

@Component({
  selector: 'app-pre-planejamento-list',
  templateUrl: './pre-planejamento-list.component.html',
  styleUrls: ['./pre-planejamento-list.component.scss']
})
export class PrePlanejamentoListComponent extends BaseListComponent {

  public dataSource = new MatTableDataSource<IListaQuestionarioRespostaUGModel>([]);
  public selectedModel: IListaQuestionarioRespostaUGModel;
  public searchNome: string;
  public filtro = {} as FiltroQuestionarioUG;
  public displayedColumns: string[] = ['selecao', 'nomeFuncionalidade', 'siglaUG', 'responsavel', 'dataEnvio', 'dataPrazo', 'status'];
  public totalItens: number;
  public pageEvent: any;
  public semDados = true;
  private segmentoUrl: string;
  public documento: string;
  public isPEA: boolean;

  @ViewChild('TableOnePaginator', { static: true }) tableOnePaginator: MatPaginator;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private route: ActivatedRoute,
    private questionarioUGService: EntendendoEntidadeService,
    private router: Router,
    private toastr: ToastrService,
    private sharedService: SharedService
  ) {
    super();
    this.buscar();
  }

  sortData(sort) {
    this.filtro.colunaOrder = sort.active;
    this.filtro.direcao = sort.direction;

    this.buscar();
  }

  public buscar() {
    this.selectedModel = null;
    this.filtro.pesquisa = this.searchNome;
    this.questionarioUGService
      .ObterQuestionarioPendente(this.filtro)
      .then((res) => {
        this.dataSource = new MatTableDataSource<IListaQuestionarioRespostaUGModel>(res.dados.resultado);
        this.paginator = this.tableOnePaginator;
        this.paginator.length = res.dados.resultado.length;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sortingDataAccessor = sortingDataAccessor;
        this.dataSource._updateChangeSubscription();
        this.semDados = this.dataSource.filteredData.length === 0;
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem);
      })
  }

  // async buscar1() {
  //   this.selectedModel = null;
  //   this.criteriosAvaliacaoService
  //     .obter(this.filtro.pesquisa, this.filtro.ativo, false)
  //     .then((res) => {
  //       this.dataSource = new MatTableDataSource<any>(res.dados);
  //       this.paginator = this.tableOnePaginator;
  //       this.paginator.length = res.dados.length;
  //       this.dataSource.sort = this.sort;
  //       this.dataSource._updateChangeSubscription();
  //       this.semDados = this.dataSource.filteredData.length === 0;
  //     })
  //     .catch((err) => {
  //       this.exibirMensagemErro(err.mensagem);
  //     });
  // }

  public responder(id: number) {
    if (this.selectedModel.tipoQuestionarioId === 12) {
      this.router.navigate([`riscos-chaves-preenchimento-form/${id}`]);
      this.sharedService.setParams(null, null, null, 'responder');
    }
    else if (this.selectedModel.tipoQuestionarioId === 11) {
      this.router.navigate([`universo-auditavel-preechimento-form`]);
      this.sharedService.setParams(this.selectedModel.idUG, id, this.selectedModel.tipoUniversoId, 'preechimento-ug');
    } else {
      this.router.navigate([`questionario/pre-planejamento-resposta/${id}`]);
    }
  }

  public print(id: number) {
    debugger
    if (this.selectedModel.tipoQuestionarioId === 12) {
      this.router.navigate([`riscos-chaves-preenchimento-form/${id}/imprimir/${this.selectedModel?.status}`]);
    } else if (this.selectedModel.tipoQuestionarioId === 11) {
      this.router.navigate([`questionario/pre-planejamento-resposta/${id}/imprimir`]);
    }
  }

  public visualizarQuestionario(id: number) {
    if (this.selectedModel.tipoQuestionarioId === 12) {
      this.router.navigate([`riscos-chaves-preenchimento-form/${id}/visualizar/${this.selectedModel?.status}`]);
    } else if (this.selectedModel.tipoQuestionarioId === 11) {
      this.router.navigate([`visualizar-universo-auditavel/${id}`]);
    } else {
      this.router.navigate([`questionario/pre-planejamento-resposta/${id}/visualizar`]);
    }
  }



  public selecionar(item: any) {
    this.selectedModel = !this.selectedModel || this.selectedModel.id !== item.documentoId ? item : null;
  }

  ngOnInit(): void {
    this.filtro.situacao = "Todos";
  }

  pageChanged(e: any) {
    this.filtro.pagina = e.pageIndex + 1;
    e.pageIndex = this.filtro.pagina;
    this.filtro.itensPorPagina = e.pageSize;
    this.buscar();
  }

}
